'use strict';

var _ = require('lodash');
var ROMOptGroupWeekFilterFactory = function ROMOptGroupWeekFilterFactory(DataFilter) {
  function ROMOptGroupWeekFilter() {
    DataFilter.call(this, ['rom-analysis-loco-mode', 'rom-analysis-demand-pax-mode', 'rom-analysis-flattened-services-mode', 'rom-analysis-skinny-services-mode', 'rom-summary-mode', 'rom-summary-top-opp-spill-mode', 'rom-summary-top-opp-recap-mode'], 'filter-component', 1);
  }
  ROMOptGroupWeekFilter.prototype = Object.create(DataFilter.prototype);
  ROMOptGroupWeekFilter.prototype.filter = function (data, range) {
    var criteria = _.chain(range).map('optGroupWeek').flatten().uniq().value();
    var filtered = [];
    if (data[0] && data[0].optGroupWeek !== undefined) {
      return DataFilter.prototype.filter(data, criteria, 'optGroupWeek');
    } else {
      for (var dataIndex = 0, dataLength = data.length; dataIndex < dataLength; dataIndex++) {
        for (var optWeeksIndex = 0, optWeeksLength = data[dataIndex].optGroupWeeks.length; optWeeksIndex < optWeeksLength; optWeeksIndex++) {
          if (criteria.indexOf(data[dataIndex].optGroupWeeks[optWeeksIndex]) !== -1) {
            filtered.push(data[dataIndex]);
            break;
          }
        }
      }
      return filtered;
    }
  };
  return ROMOptGroupWeekFilter;
};
ROMOptGroupWeekFilterFactory.$inject = ['DataFilterFactory'];
module.exports = ROMOptGroupWeekFilterFactory;